import React from 'react';

import type { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const DataList = ({ className, children }: Props) => {
  const defaultClassName = 'sm:divide-y sm:divide-gray-200';
  return <dl className={className ? className : defaultClassName}>{children}</dl>;
};
export default React.memo(DataList);
